module.exports = __webpack_public_path__ + "static/media/gallery_logo.99407536.png";